export const ItemTypes = {
  SELECT_DRAG_LIST_ITEM: 'select-drag-item',
  TABLE_WORKER_COLUMN_SIZE: 'table-worker-column-size',
  DATA_VIEWER_FILE_DIALOG: 'data-viewer-file-dialog',
};
